const resources = {
    bopisTitle: 'Buy Online and Pick Up Checkout',
    sadTitle: 'Shipping and Delivery Checkout',
    confirmSelection: 'Please confirm your selection',
    paypalAddressUnverified:
        'The shipping address from PayPal could not be verified. Please update your shipping address before continuing.'
};

export default function getResource(label) {
    return resources[label];
}
